import { css } from '@emotion/css'
import { spacing } from '../../../styles'

const styles = {
  footer: css({
    marginTop: spacing.medium,
    display: 'flex',
  }),

  actions: css({
    alignSelf: 'stretch',

    '& > *': {
      width: '100%',
    },
  }),
}

export default styles

export const footerSize = size => {
  switch (size) {
    case 'medium':
    case 'large':
      return css({
        flexDirection: 'row-reverse',
        justifyContent: 'space-between',
        alignItems: 'flex-end',

        '& > * + *': {
          marginRight: spacing.default,
        },
      })

    default:
      return css({
        flexDirection: 'column',
        alignItems: 'center',

        '& > * + *': {
          marginTop: spacing.default,
        },
      })
  }
}
